export const englishLabels = {
    planLbl: {
        plan: "Plan",
        createNewPlan: "Create a New Plan",
        copyAnExistingPlan: "Copy an Existing Plan",
        addNewPlan: "Add New Plan",
        selectExistingPlan: "Select an Existing Plan",
        railCarPlan: "Railcar Plan",
        deletePlanMsg: "You are about to delete Plan",
        confirmOpr: "Do you want to confirm the operation?",
        enterAARCarType: "Enter AAR Car Type to Add to the Plan",
        addedCarTypes: "Added Car Types",
        reviewNcont: "Review & Continue",
        assistance: "Assistance",
        assistanceMsg:
            "If you already know your car types, type them and click add to add them to the plan. If you need help, use the help me option on the bottom to find your equipment type.",
        maxPlanNameLenMsg: "Maximum Plan name length is 20",
        maxDescLenMsg: "Maximum description length is 150",
        planNameMand: "Plan Name*",
        copyOf: "Copy of",
        description: "Description",
        leStatusMand: "L/E Status*",
        clear: "Clear",
        add: "Add",
        createPlanMsg: "Let's Create a New Plan to get Started",
        cancelCreatNew: "Cancel Create New Plan",
        planDiscardConfirmMsg:
            "The plan has been creating will be discarded. Do you want to confirm the operation?",
        reviewPlan: "Review Plan",
        backtoEdit: "Back to Edit",
        deletePlan: "Delete Plan",
        review: "Review",
        good: "Good",
        maxCommentLenMsg: "Maximum Comment length is 150",
        planSuccessMsg: "successfully created.",
        equipmentType: "Equipment Type",
        commodity: "Commodity",
        leStatus: "L/E Status",
        planName: "Plan Name",
        origin: "Origin",
        destination: "Destination",
        quantity: "Quantity",
        gUnit: "g (U)",
        targetETAWindow: "Target ETA Window",
        hazardous: "Hazardous",
        addToPlan: "Add to Plan",
        cancel: "Cancel",
        apply: "Apply",
        addedCommodity: "Added Commodity Details",
        planType: "Plan Type",
        equipment: "Equipment",
        calendarView: "Calendar View",
    },

    managePlanFilterOptions: {
        PLAN_TYPE: {
            label: "Plan Type",
            name: "PlanType",
        },
    },

    carOrderLbl: {
        carOverview: "CAR OVERVIEW",
        patternInfo: "PATTERN INFO",
        patternId: "Pattern ID",
        roadId: "Road ID",
        station: "Station",
        track: "Track",
        comment: "Comment",
        commodity: "Commodity",
        railTracking: "Rail Tracking #",
        carType: "Car Type",
        carKind: "Car Kind",
        orderedBy: "Ordered By",
        submitDate: "Submit Date",
        alternativeCarType: "Alternative Car Type",
        alternativeKind: "Alternative Kind",
        newCarOrder: "New Car Order",
        selectPattern: "1. Select a Pattern",
        wanted: "Wanted",
        assigned: "Assigned",
        placed: "Placed",
        carOrder: "Car Order",
        placeTheOrder: "PLACE THE ORDER",
        orderDailyQuality: "2. Order Daily Quantity",
        maximumDailyCars: "Maximum Daily Cars",
        minimumDays: "Minimum Days",
        maximumDays: "Maximum Days",
        serviceDays: "Service Days",
        weekTotals: "Week Totals",
        confirmOrder: "Confirm Order",
        confirmOrderMessage:
            "You are about to place the new order. Do you want to confirm the operation?",
        placeCarOrderSuccessMessage: "New order has been placed.",
        placeCarOrderFailureMessage: "New order can not be placed.",
        order: "Order",
        dateWanted: "Date Wanted",
        pattern: "Pattern",
        train: "Train",
        days: "Days",
        dailyCars: "Daily Cars",
    },

    weekDays: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],

    monthsInitials: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ],

    common: {
        cancel: "Cancel",
        confirm: "Confirm",
        apply: "Apply",
        edit: "Edit",
        delete: "Delete",
        create: "Create",
        details: "Details",
        selectPlan: "Select Plan",
        front: "Front",
        back: "Back",
        andOr: "and/or",
        managePlan: "Manage Plan",
        managePlans: "Manage Plans",
        addNewPlan: "Add New Plan",
        default: "Default",
        plan: "Plan",
        railCarStatus: "Railcar Status",
        onHand: "On Hand",
        inBound: "Inbound",
        planned: "Planned",
        projected: "Projected",
        summaryMetrics: "Summary & Metrics",
        lastUpdatedInfo: "Last updated Info",
        modifiedBy: "Modified by",
        carOrder: "Car Order",
        currentWeek: "*Current Week",
        download: "Download",
        updatePlan: "Update Plan",
        save: "Save",
        previous30Days: "Previous 30 Days",
        next30Days: "Next 30 Days",
        load: "Load",
        empty: "Empty",
        all: "Load/Empty",
        newOrder: "New Order",
        latestWantDate: "Want Date",
        latestSubmitDate: "Submit Date",
        latestOrderName: "Order Number",
        filter: "Filter",
        reset: "reset",
        open: "Open",
        completed: "Completed",
        canceled: "Canceled",
        closed: "Closed",
        complete: "Complete",
        inputRange: "Input Range",
        dateRange: "Date Range",
        dateRangePicker: "Date Range Picker",
        datePicker: "Date Picker",
        week: "Week",
        metric: "Metric",
        maximum31Days: "31 days maxiumum",
        next: "NEXT",
        clear: "CLEAR",
        dashboard: "Dashboard",
        requiredFields: "Required Fields",
        sortBy: "Sort by",
        status: "Status",
        clearAll: "Clear All",
        totalEquipmentHeader: "Total Equipment",
        lastUpdated: "Last updated",
        at: "at",
        search: "Search",
        noRecordsFound: "No records found",
        searchOnAnyField: "Search on any field",
        loadingData: "Loading...",
        logout: "Logout",
        selectedEquipment: "Selected Equipment",
        yes: "Yes",
        no: "No",
        loaded: "Loaded",
        name: "Name",
        loadStatus: "Load Status",
        date: "Date",
        activeTrains: "Active Trains",
        noResultsFound: "No Results Found",
        noRailRoadError:
            "configuration is incomplete. Please contact Wabtec support.",
        close: "Close",
        continueEditing: "Continue Editing",
        type: "Type",
        email: "Email",
        required: "Required",
        private: "Private",
        public: "Public",
        faq: "FAQ",
        releasenotes: "Release Notes",
        noOrganizationsFound: "No Organizations Found",
        InvalidEmailAddress: "Invalid email address",
        DuplicateMailNotAllowed: "Duplicate emails not allowed",
        InvalidOrDupEmail: "Invalid or duplicate email address",
        Max4000Chars: "Maximum of 4000 characters allowed",
        savedSuccessfully: "Saved successfully",
        New: "New",
        Contents: "Contents",
        successfullyUpdated: "successfully updated.",
    },

    dashboard: {
        badOrderEqStatus: "BAD ORDER EQUIPMENT STATUS",
        storageEqStatus: "STORAGE EQUIPMENT STATUS",
        badOrder: "Bad Order",
        overweight: "Overweight",
        hazmat: "Hazmat",
        onHold: "On Hold",
        holdMisc: "HOLD/MISC.",
        inventory: "Inventory",
        enroute: "Enroute",
        inbound: "Inbound",
        onHand: "On Hand",
        outbound: "Outbound",
        enrouteDesc: "En Route - to my Railroad",
        inboundDesc: "Inbound - to my Facility",
        onHandDesc: "On Hand - at my Facility",
        outboundDesc: "Outbound - Pulled from my Facility",
        load: "Load",
        empty: "Empty",
        netTon: "Net Ton",
        tonnage: "Tonnage",
        netTons: "Net Tons",
        noEta: "No ETA",
        storage: "Storage",
        inboundPipeline: "7 DAYS INBOUND PIPELINE",
        railroadDwellTime: "Railroad dwell time",
        shipperDwellTime: "Shipper dwell time",
        planName: "Plan Name",
        totalCars: "Total Cars",
        total: "Total",
        badOrderEq: "Bad Order Equipment",
        totalEquipment: "Total Equipment",
        storageEquipment: "Storage Equipment",
        totalOnlineEquipment: "TOTAL ONLINE EQUIPMENT",
        onlineEquipStatus: "ONLINE EQUIPMENT STATUS",
        onTrains: "On Trains",
        onTracks: "On Tracks",
        totalOnline: "Total Online",
        dwellTime: "Dwell Time",
        lessThan24: "< 24 Hours",
        hours24to48: "24 - 48 Hours",
        greaterThan48: "> 48 Hours",
        railroadDwellInfo:
            "-Railroad Dwell Time: A summary of idle equipment that is not in storage, bad order, on hold, constructive placement, or actually placed.",
        shipperDwellInfo:
            "-Shipper Dwell Time: A summary of idle equipment that is currently placed at my facility.",
        totalStorage: "Total Storage",
        forecasting: "Forecasting",
        others: "Others",
        totalNetTons: "TOTAL NET TONS",
        totalCommodities: "TOTAL COMMODITIES",
        badOrderInfo:
            "Equipment in bad order (BGLT or BHVY) status. Equipment that is in need of repair.",
        overWeightInfo:
            "Equipment in overweight status. Equipment that the total weight  exceeds capacity of track or equipment.",
        inventoryInfo:
            "A summary of equipment counts broken out by shipment type that can be filtered by loads or empties.",
        netTonsInfo:
            "A summary of net tons by commodity that can be filtered by individual shipment types.",
        hazmatInfo: "Equipment that containes a hazardous commodity.",
        storageInfo:
            "Equipment that is in storage (STEA, STEX, STPL, STSE, STSU, or STUN) status. Equipment that is requested to be held, and is subject to storage charges.",
        constructivelyPlacedInfo:
            "Equipment in constructive placement (PCON) status. Equipment that cannot be placed for loading or unloading, and could be subject to demurrage charges.",
        onHoldInfo:
            "Equipment in hold (HMIS) status. Equipment that has been requested to be held by the railroad. *This is not an embargo hold.",
        placedFacilityInfo:
            "Equipment in actual placement (PACT) status at my facility.",
        releasedFacilityInfo:
            "Equipment in release (RLOD or RMTY) status at my facility.",
        placedAtFacility: "Placed at facility",
        releasedAtFacility: "Released at Facility",
        noEtaForecasting:
            "No ETA: Equipment that is currently missing an ETA. Forecasting: A summary of current forecasting plans for the next 7 days.",
        enRouteToMyRailroad: "En route to my railroad",
        inBoundToMyFacility: "Inbound to my facility",
        onHandAtMyFacility: "On hand at my facility",
        outboundFromMyFacility: "Outbound from my facility",
        interModalLoad: "Intermodal Load",
        interModalEmpty: "Intermodal Empty",
    },

    imagePath: {
        A: "/images/RailCars/Box_car_",
        B: "/images/RailCars/Box_car_",
        C: "/images/RailCars/Hopper_",
        H: "/images/RailCars/Hopper_",
        K: "/images/RailCars/Hopper_",
        E: "/images/RailCars/Gondola_",
        G: "/images/RailCars/Gondola_",
        U: "/images/RailCars/Gondola_",
        J: "/images/RailCars/Gondola_",
        F: "/images/RailCars/Flatcar_",
        V: "/images/RailCars/Flatcar_",
        I: "/images/RailCars/Intermodal_",
        P: "/images/RailCars/Intermodal_",
        R: "/images/RailCars/Refrigerator_",
        S: "/images/RailCars/Stack_car_",
        T: "/images/RailCars/Tank_car_",
        Z: "/images/RailCars/Trailer_",
    },

    errorLabel: {
        overCapacity: "Over Capacity",
    },

    visibilityLbl: {
        visibility: "Visibility",
        totalOnlineEquipment: "Total Equipment : ",
        lastUpdated: "Last updated : ",
        actionPanel: "ACTION PANEL",
        action: "ACTION",
        listedEquipment: "Listed Equipment : ",
        spot: "Spot",
        station: "Station",
        stations: "Stations",
        track: "Track",
        equipId: "Equip. ID",
        shipmentType: "Shipment Type",
        comment: "Cmnt",
        wayBillNumber: "Waybill No",
        equipmentKind: "Kind",
        equipmentType: "Equip Type",
        carStatus: "L/E",
        commodity: "Commodity",
        lastMovType: "Last Move Type",
        createBill: "Create Bill",
        badOrder: "Bad Order",
        hold: "Hold",
        intraPlant: "Intra Plant",
        move: "Move",
        outOfStorage: "Out of Storage",
        place: "Place",
        reject: "Reject",
        releaseEmpty: "Release Empty",
        releaseInSameStatus: "Release in Same Status",
        releaseReload: "Release & Reload",
        turn: "Turn",
        weigh: "Weigh",
        downloadCSV: "Export to CSV",
        clearActionPanelList: "Clear Action Panel List",
        rejectReason: "Reject Reason",
        inventory: "Inventory",
        requestDateMand: "Request Date *",
        requestTimeMand: "Request Time *",
        spotStartfrom: "Spot (Start from)",
        other: "Other",
        otherReason: "Other Reason",
        Comment: "Comment",
        columnsCustomizations: "Columns Customizations",
        ebolFailureMessage:
            "There is an issue with your eBOL profile. Please contact support",
        actuallyPlaced: "Actually Placed",
        constructivelyPlaced: "Constructively Placed",
        released: "Released",
        ownerDetails: "Owner Details",
        actionResult: "Action Result",
        actionProcessedSuccessfully: "Processed Successfully",
        inTransit: "In-Transit",
        arrivedAtFD: "Arrived at Final Destination",
        tripComplete: "Trip Complete",
        warning: "Warning",
        resequence: "Resequence",
        resequenceDoneMsg:
            "Resequence request has been completed successfully.",
        resequenceFailedMsg: "Resequence request was unable to process.",
        resequenceWarning:
            "You are about to close a dialog without saving. All changes will be lost. Are you sure you want to close without saving?",
        unsavedChanges: "Unsaved changes",
        loadingData: "Loading data",
        loadingFailed: "Loading Failed",
        equipmentSearch: "Equipment Search",
        equipmentMultiSearch: "Equipment Multi Search",
        multiSearchSubtext1:
            "Paste or type the text into the area below and then click Search Equipment",
        multiSearchSubtext2:
            "*RVP can accept data pasted from Excel, comma separated field data and plain text.",
        multiSearchSubtext3:
            "Paste up to 150 pieces of equipment to search at once.",
        equiment: "Equipment",
        equipmentFormat: "Enter equipment IDs, e.g. ABCD 123456, EFG 000123",
        searchEquipment: "Search Equipment",
        notFound: "Not found",
        invalidEquipmentFormatMsg:
            "The data format you have entered is not valid. Please correct format and try again (e.g. ABCD 123456, EFG 000123).",
        notFoundRailcarsMsg:
            "These railcars were not found in the system. Edit the errors and click ‘Search equipment’ button to proceed.",
        equipmentFound: "Equipment found",
        originAndDestination: "Origin and Destination",
        parties: "Parties",
        dateAndMovements: "Dates and Movements",
        equipmentAndCommodity: "Equipment and Commodity",
        equipmentIndicators: "Equipment Indicators",
        etaDataNotAvailable: "ETA data not available",
        etiDataNotAvailable: "ETI data not available",
        shippedDataNotAvailable: "SHIPPED DATE data not available",
        lmDataNotAvailable: "Last Movement Date data not available",
        hasComments: "Comments Available",
        ETI: "Estimated Time of Interchange",
        ETA: "Estimated Time of Arrival",
        noETA: "No ETA",
        exception: "Exception",
    },

    actionMenuOne: ["Create Bill"],

    actionMenuTwo: [
        "Hold",
        "Place",
        "Reject",
        "Turn",
        "Weigh",
        "Out of Storage",
        "Intra Plant",
        "Move",
        "Release Empty",
        "Release & Reload",
        "Release in Same Status",
        "Bad Order",
    ],

    actionMenuThree: ["Download CSV. File", "Clean Action Panel List"],

    calendar: {
        clear: "Clear",
    },

    shipmentTypes: {
        1: "En Route",
        2: "Inbound",
        3: "On Hand",
        4: "Outbound",
        5: "Outbound",
    },

    shipmentTypeActionMapper: {
        1: ["Hold", "Place", "Turn", "Weigh"],
        2: [
            "Hold",
            "Place",
            "Reject",
            "Turn",
            "Weigh",
            "Bad Order",
            "Out of Storage",
            "Create Bill",
        ],
        3: [
            "Hold",
            "Place",
            "Reject",
            "Turn",
            "Weigh",
            "Bad Order",
            "Out of Storage",
            "Intra Plant",
            "Move",
            "Release Empty",
            "Release in Same Status",
            "Release & Reload",
            "Create Bill",
        ],
        4: [
            "Out of Storage",
            "Release Empty",
            "Release in Same Status",
            "Release & Reload",
            "Create Bill",
        ],
        5: [
            "Release Empty",
            "Release in Same Status",
            "Release & Reload",
            "Create Bill",
        ],
    },

    shipmentTypeTrackAndSpotOperationIndicator: {
        Hold: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Place: {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },
        Reject: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Turn: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Weigh: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        "Bad Order": {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        "Out of Storage": {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        "Intra Plant": {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },
        Move: {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },
        "Release Empty": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
        "Release in Same Status": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
        "Release & Reload": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
        "Create Bill": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
    },

    wayBillInformationLbl: {
        waybillNumber: "Waybill Number",
        waybillDate: "Waybill Date",
        equipmentKind: "Equipment Kind",
        status: "Status",
        blockTo: "Block To",
        leStatus: "L/E Status",
        stcc: "STCC",
        billOfLading: "Bill of Lading",
        badOrderStatus: "Bad Order Status",
        multiCar: "Multicar",
        tmc: "TMC",
        currentStation: "Current Station",
        currentTrack: "Current Track",
        lastMoveType: "Last Move Type",
        activityIndication: "Activity Indicator",
        lastMoveDateTime: "Last Move Date & Time",
        wayBill: "WAYBILL",
        originDestinations: "Destination & Origin Stations",
        origin: "Origin",
        destination: "Destination",
        fsac: "FSAC",
        city: "City",
        state: "State",
        country: "Country",
        routing: "Routing",
        role: "Role",
        railRoad: "RailRoad",
        juntion: "Junction",
        shipper: "Shipper",
        companyName: "Company Name",
        address: "Address",
        zipCode: "Zip Code",
        customers: "Customers",
        consignee: "Consignee",
        inCareofParty: "In Care of Party",
        equipmentDetails: "Equipment Details",
        information: "Information",
        specifications: "Specifications",
        equipmentID: "Equipment ID",
        aARType: "AAR Type",
        outsideLength: "Outside Length (ft, in)",
        outsideHeight: "Outside Height (ft, in)",
        reclaimCode: "Reclaim Code",
        outsideWidth: "Outside Width (ft, in)",
        weightCode: "Weight Code",
        carHireFlag: "Car Hire Flag",
        haulage: "Haulage",
        netWeight: "Net Weight (kg, lbs, ton)",
        tare: "Tare (kg, lbs, ton)",
        methodCode: "Method Code",
        eDIType: "EDI Type",
        allowanceKg: "Allowance (kg, lbs, ton)",
        commodity: "Commodity",
        detail: "Detail",
        description: "Description",
        productGroup: "Product Group",
        Weightkglbston: "Weight (kg, lbs, ton)",
        weightType: "Weight Type",
        overweightIND: "Overweight IND",
        ladingQTY: "Lading Qty",
        unit: "Unit",
        commodityDetail: "COMMODITY DETAIL",
        hazmatDetail: "HAZMAT DETAIL",
        placardNotation: "Placard Notation",
        personCertifyingtheShipment: "Person Certifying the Shipment",
        tIHPIH: "TIH/PIH",
        ladingQty: "Lading Qty",
        ladingUnit: "Lading Unit",
        packingGroup: "Packing Group",
        hazmatPhoneNumber: "24H Hazmat Phone Number",
        volumeWeightQty: "Volume Weight Qty",
        volumeWeightUnit: "Volume Weight Unit",
        canadianHazmatInformation: "Canadian Hazmat Information",
        emergencyResponsePlanNumber: "Emergency Response Plan Number",
        packingGroupCode: "Packing Group Code",
        HazmatNotation: "Hazmat Notation",
        emergencyResponseTelephoneNumber: "Emergency Response Telephone Number",
        uNHazmatIdentificationInformation:
            "UN Hazmat Identification Information",
        uNNACode: "UN/NA Code",
        uNHazardPageNumber: "UN Hazard Page Number",
        emergencyContact: "Emergency Contact",
        references: "References",
        outbound: "Outbound",
        onHand: "On Hand",
        inbound: "Inbound",
        enRoute: "En Route",
        referenceCode: "Reference Code",
        referenceInfo: "Reference Info",
        referenceDateTime: "Reference Date Time",
        repeatingGroup: "Repeating Group",
        overview: "Overview",
        hazmat: "Hazmat",
        tripHistory: "Trip History",
        noTripHistory: "No equipment movement found",
        currentEvent: "Current Event",
        notPlanned: "Not Planned",
    },

    waybillTripHistoryColumns: {
        MOVE_TYPE: {
            headerName: "Move Type",
            field: "EventDescription",
        },
        MOVE_TIME: {
            headerName: "Move Time",
            field: "EventDate",
        },
        MOVE_CITY: {
            headerName: "Move City",
            field: "EventCityState",
        },
        EVENT: {
            headerName: "Event",
            field: "EventType",
        },
        STATION: {
            headerName: "Station",
            field: "StationName",
        },
        PLANNED_DATE_TIME: {
            headerName: "Planned Date & Time",
            field: "PlannedEventDate",
        },
        ACTUAL_DATE_TIME: {
            headerName: "Actual Date & Time",
            field: "ActualEventDate",
        },
        VARIANCE: {
            headerName: "Variance",
            field: "Variance",
        },
    },

    visibilityColumnGroups: {
        CURRENT_LOCATION: "Current Location",
        EQUIPMENT_INFO: "Equipment Info",
        LAST_MOVEMENT_INFO: "Last Movement Info",
        SHIPPED_INFO: "Shipped Info",
        ETA_INFO: "ETA Info",
        PLACEMENT_INFO: "Placement Info",
        WEIGHT_INFO: "Weight Info",
    },

    visibilityColumns: {
        STATION: {
            headerName: "Station",
            field: "Station",
        },
        TRACK: {
            headerName: "Track",
            field: "Track",
        },
        TRACK_SEQ: {
            headerName: "Seq",
            field: "TrackSequence",
        },
        EQUIP_ID: {
            headerName: "Equipment",
            field: "Railcar",
        },
        SHIPMENT_TYPE: {
            headerName: "Shipment Type",
            field: "ShipmentType",
        },
        BLOCK_TO: {
            headerName: "Block To",
            field: "BlockTo",
        },
        COMMENT: {
            headerName: "Cmnt",
            field: "Cmnt",
        },
        WAYBILL_NO: {
            headerName: "Waybill No",
            field: "WaybillNumber",
        },
        BOL_NO: {
            headerName: "BOL No",
            field: "BOLNumber",
        },
        EQUIPMENT_KIND: {
            headerName: "Kind",
            field: "Equip_Kind",
        },
        CAR_TYPE: {
            headerName: "Equip Type",
            field: "CarType",
        },
        EQUIP_KIND: {
            headerName: "Equip Kind",
            field: "CarKind",
        },
        LE_STATUS: {
            headerName: "L/E",
            field: "LoadEmptyStatus",
        },
        COMMODITY: {
            headerName: "Commodity",
            field: "CommodityDescription",
        },
        EVENT_ROAD: {
            headerName: "Current Railroad",
            field: "EventRoad",
        },
        EVENT_CODE: {
            headerName: "Last Move Type",
            field: "EventCode",
        },
        EVENT_CITY_STATE: {
            headerName: "Last Move City",
            field: "EventCityState",
        },
        EVENT_DATE: {
            headerName: "Last Move Date",
            field: "EventDate",
        },
        CARRIER: {
            headerName: "Carrier",
            field: "Carrier",
        },
        SHIPPED_DATE: {
            headerName: "Shipped Date",
            field: "ShippedDate",
        },
        ORIGIN_CITY: {
            headerName: "Origin City",
            field: "OriginCityState",
        },
        SHIPPER: {
            headerName: "Shipper",
            field: "Shipper",
        },
        ETA: {
            headerName: "ETA",
            field: "ETA",
        },
        ETI: {
            headerName: "ETI",
            field: "ETI",
        },
        TRIP_STATUS: {
            headerName: "Trip Status",
            field: "TripStatus",
        },
        EXCEPTION: {
            headerName: "Exception",
            field: "Exception",
        },
        DESTINATION_CITY: {
            headerName: "Destination City",
            field: "DestinationCityState",
        },
        AI: {
            headerName: "AI",
            field: "ActivityIndicator",
        },
        CONSIGNEE: {
            headerName: "Consignee",
            field: "Consignee",
        },
        ROUTE: {
            headerName: "Route",
            field: "Route",
        },
        ONLINE_DEST: {
            headerName: "Online Destination",
            field: "PlacementLocation",
        },
        PLACEMENT_AVAILABLE: {
            headerName: "Available",
            field: "AvailableForPlacement",
        },
        PLACEMENT_STATUS: {
            headerName: "Placement Status",
            field: "PlacementStatus",
        },
        PLACEMENT_DATE: {
            headerName: "Placement Date",
            field: "PlacementDate",
        },
        NET_TON: {
            headerName: "Net Ton",
            field: "NetTons",
        },
        TARE_WEIGHT: {
            headerName: "Tare Weight",
            field: "TareWeight",
        },
        GROSS_WEIGHT: {
            headerName: "Gross Weight",
            field: "GrossWeight",
        },
        OVER_WEIGHT: {
            headerName: "Overweight",
            field: "OverweightStatus",
        },
        LOAD_LIMIT: {
            headerName: "Load Limit",
            field: "LoadLimit",
        },
        TOTAL_WEIGHT: {
            headerName: "Total Rail Weight",
            field: "TotalWeightOnRail",
        },
        TRAIN_ID: {
            headerName: "Train ID",
            field: "TrainID",
        },
        PRODUCT_GROUP: {
            headerName: "Product Group",
            field: "ProductGroup",
        },
        CAR_LENGTH: {
            headerName: "Car Length",
            field: "CarLength",
        },
    },

    shipmentTypeLabels: {
        EN_ROUTE: "En Route",
        INBOUND: "Inbound",
        ON_HAND: "On Hand",
        OUTBOUND: "Outbound",
    },

    visibilityFilterOptions: {
        EQUIP_ID: {
            label: "Equipment",
            name: "equipment",
        },
        SHIPPER: {
            label: "Shipper",
            name: "shippers",
        },
        CAR_TYPES: {
            label: "Equip Type",
            name: "CarTypes",
        },
        EQUIP_KIND: {
            label: "Equip Kind",
            name: "EquipKind",
        },
        LOAD_STATUS: {
            label: "Load Status",
            name: "loadStatus",
        },
        EVENT_CODES: {
            label: "Last Movement Type",
            name: "eventCodes",
        },
        HAZARDOUS: {
            label: "Hazardous",
            name: "Hazardous",
        },
        OVER_WEIGHT: {
            label: "Overweight",
            name: "OverweightStatus",
        },
        UNIT_CAR: {
            label: "Unit Train",
            name: "UnitCar",
        },
        ORIGIN: {
            label: "Origin",
            name: "Origin",
        },
        LOAD_LIMIT: {
            label: "Load Limit",
            name: "loadLimit",
        },
        BILLED: {
            label: "Billed",
            name: "Billed",
        },
        EVENT_DATES: {
            label: "Last Movement Date",
            name: "eventDates",
        },
        BAD_ORDER: {
            label: "Bad Order",
            name: "BadOrder",
        },
        WITH_COMMENTS: {
            label: "Comments",
            name: "WithComments",
        },
        CONSIGNEE: {
            label: "Consignee",
            name: "Consignee",
        },
        TOTAL_WEIGHT: {
            label: "Total Rail Weight",
            name: "totalWeight",
        },
        SHIPPED_DATE: {
            label: "Ship Date",
            name: "ShippedDate",
        },
        PLACEMENT_STATUS: {
            label: "Placement Status",
            name: "PlacementStatus",
        },
        STORAGE: {
            label: "Storage",
            name: "Storage",
        },
        ONHOLD: {
            label: "On Hold",
            name: "OHold",
        },
        DESTINATION: {
            label: "Destination",
            name: "Destination",
        },
        COMMODITY: {
            label: "Commodity",
            name: "Commodity",
        },
        ETA: {
            label: "ETA",
            name: "Eta",
        },
        ETI: {
            label: "ETI",
            name: "Eti",
        },
        ACTIVITY_INDICATOR: {
            label: "Activity Indicator",
            name: "ActivityIndicator",
        },
        CARRIER: {
            label: "Carrier",
            name: "Carrier",
        },
        PLACEMENT_AVAILABLE: {
            label: "Available",
            name: "PlacementAvailable",
        },
        CAR_KIND: {
            label: "Car Kind",
            name: "CarKind",
        },
        STCC: {
            label: "STCC",
            name: "Stcc",
        },
        EVENT_ROAD: {
            label: "Current Railroad",
            name: "eventRoad",
        },
        RAILROAD_DWELL_TIME: {
            label: "Railroad Dwell Time",
            name: "RailroadDwellTime",
        },
        SHIPPER_DWELL_TIME: {
            label: "Shipper Dwell Time",
            name: "ShipperDwellTime",
        },
        BLOCK_TO: {
            label: "Block To",
            name: "BlockTo",
        },
        NO_ETA: {
            label: "No ETA",
            name: "NoEta",
        },
        EXCEPTION: {
            label: "Exception",
            name: "Exception",
        },
    },

    planningLbl: {
        Help_Me_Finding_Car_Types: "Help Me Finding Car Types",
        Which_Car_Type_Fits_Your_Needs: "Which Car Type Fits Your Needs",
        Select_First_Number: "Select the First Number",
        Select_the_Second_Number: "Select the Second Number",
        Select_First_And_Second_Number: "Select the First and Second Number",
        Now_Select_Third_Number: "Now Let's Select the Third Number",
        Select_the_Third_Number: "Select the Third Number",
    },

    actionCodesNumbers: {
        hold: "1",
        place: "2",
        reject: "3",
        turn: "4",
        weigh: "5",
        createbill: "6",
        outofstorage: "7",
        intraplant: "8",
        move: "9",
        releaseempty: "10",
        "release&reload": "11",
        releaseinsamestatus: "12",
        badorder: "13",
    },

    reviewCarsColumns: [
        {
            headerName: "Equipment ID",
            field: "equipmentID",
            maxWidth: 160,
            suppressMovable: true,
        },
        {
            headerName: "L/E Status",
            field: "leStatus",
            maxWidth: 130,
            suppressMovable: true,
        },
        {
            headerName: "Car Type",
            field: "carType",
            maxWidth: 120,
            suppressMovable: true,
        },
        {
            headerName: "Car Kind",
            field: "carKind",
            maxWidth: 120,
            suppressMovable: true,
        },
        {
            headerName: "Destination",
            field: "destination",
            maxWidth: 200,
            suppressMovable: true,
        },
        {
            headerName: "Status",
            field: "status",
            resizable: false,
            suppressMovable: true,
            minWidth: 85,
            maxWidth: 85,
            cellStyle: (params) => {
                let styles = {
                    borderRadius: "16px",
                    height: "32px",
                    top: "0px",
                    bottom: "0px",
                    margin: "auto",
                    lineHeight: "32px",
                    paddingRight: "0px",
                    paddingLeft: "0px",
                    textAlign: "center",
                }
                if (params.value === "Assigned") {
                    styles.backgroundColor = "#fec600"
                } else if (params.value === "Wanted") {
                    styles.backgroundColor = "lightgrey"
                } else if (params.value === "Placed") {
                    styles.backgroundColor = "#7fae1b"
                }
                return styles
            },
        },
        {
            headerName: "Track",
            field: "track",
            maxWidth: 180,
            suppressMovable: true,
        },
        {
            headerName: "Train",
            field: "train",
            maxWidth: 180,
            suppressMovable: true,
        },
    ],

    viewsLbl: {
        views: "Views",
        savedView: "Saved Views",
        manageView: "Manage Views",
        resetView: "Reset Views",
        saveView: "Save View",
        saveCurrentView: "Save Current View",
        manageCurrentView: "Manage Current View",
        resetCurrentView: "Reset Current View",
        saveViewSubTitle:
            "Save this combination of filters, columns, view modes, and color categories.",
        saveNewView: "Save New View",
        updateExistingView: "Update Existing View",
        makeThisMyDefaultView: "Make this my default view",
        descriptionOptional: "Description (optional)",
        saveChanges: "SAVE  CHANGES",
        enterNameHere: "Enter Name Here",
        selectAView: "Select A View",
        applyView: "APPLY VIEW",
        publicRailroad: "Public – Railroad",
        publicCorporation: "Public – Corporation",
        viewManager: "View Manager",
        viewManagerSubTitle: "Select a view to apply to the page",
        activeView: "Active View",
        none: "None",
        viewName: "View Name",
        owner: "Owner",
        description: "Description",
        default: "Default",
        actions: "Actions",
        editView: "Edit View",
        deleteView: "Delete View",
        setAsDefault: "Set as Default",
        areYouSureYouWantToDelete: "Are you sure you want to delete",
        yesDeleteThisView: "Yes, Delete this view",
        successfullyDeleted: "successfully deleted.",
        dismiss: "Dismiss",
        successfullyUpdated: "successfully updated.",
        previousDescriptionShownHere: "Previous description shown here",
        eta: "ETA",
        totalCars: "Total Cars",
        view: "view",
        successfullyCreated: "successfully created.",
        publicViewHelperText:
            "Note: Public views are visible to your selected audience. Only the creator or authorized leads can edit.",
        publicViewsLimitWarning:
            "You're almost at the limit. You can have up to 10 public views.",
        publicViewsLimitError:
            "You've reached the limit for public views. You can have up to 10 public views. To add a new one, make an existing view private or delete one.",
        publicViewsThresholdExceeded:
            "Stored public views exceed the usable threshold of 10.",
        validationViewSave:
            "A view with this name already exists. Please choose a different name.",
    },

    demurrage: {
        storage: "Storage",
        chargeManagement: "Charge Management",
        demurrage: "Demurrage",
        pending: "Pending",
        invoiced: "Invoiced",
        inDispute: "In Dispute",
        downloadCSV: "Export to CSV",
        search: "Search",
        searchOnAnyField: "Search on any field",
        total: "Total",
        customer: "Customer",
        accountingPeriod: "Accounting Period",
        serviceType: "Service Type",
        calculation: "Calculation",
        holdType: "Hold Type",
        transactionFrom: "Transactional Dates From",
        transactionTo: "Transactional Dates To",
        railroad: "Railroad",
        status: "Status",
        le: "L/E",
        ownerType: "Owner Type",
        commodity: "Commodity",
        cycleType: "Cycle Type",
        LE: "L/E",
        OWNER_TYPE: "Owner Type",
        COMMODITY: "Commodity",
        CYCLE_TYPE: "Cycle Type",
        CUST_ID: "Customer ID",
        SERVICE_TYPE: "Service Type",
    },
    errorPage: {
        description:
            "Sorry about that, but you don't have permission to access this page. Please contact your system administrator if you think this is an error",
    },
    demurrageSummaryColumns: {
        DATE: {
            headerName: "Date",
            field: "Date",
        },
        CUST_ID: {
            headerName: "Customer ID",
            field: "CustomerId",
        },
        SERVICE_TYPE: {
            headerName: "Service Type",
            field: "ServiceType",
        },
        HOLD_TYPE: {
            headerName: "Hold Type",
            field: "HoldType",
        },
        INVOICE: {
            headerName: "Invoice",
            field: "InvoiceNumber",
        },
        CALCULATION: {
            headerName: "Calculation",
            field: "CalculationType",
        },
        CARS: {
            headerName: "Cars",
            field: "TotalRailcars",
        },
        TOTAL_CHARGES: {
            headerName: "Total Charges",
            field: "TotalCharges",
        },
        STATUS: {
            headerName: "Status",
            field: "Status",
        },
    },

    holdTypeLabels: {
        OTHER: "Other",
        STORAGE: "Storage",
        UNLOAD: "Unload",
        LOAD: "Load",
    },

    calculationTypeLabels: {
        AVERAGE: "Average",
        SIMPLIFIED: "Simplified",
        STRAIGHT: "Straight",
        STORAGE: "Storage",
    },

    serviceTypeLabels: {
        DEMURRAGE: "Demurrage",
    },

    demurrageDetailsColumns: {
        LN: {
            headerName: "Ln",
            field: "",
        },
        EQUIPMENT_INFO: {
            headerName: "Equipment",
            field: "Railcar",
        },
        LE_STATUS: {
            headerName: "L/E",
            field: "DemurrageMoveType",
        },
        OWNER_TYPE: {
            headerName: "Owner Type",
            field: "IsPrivateEquipment",
        },
        COMMODITY: {
            headerName: "Commodity",
            field: "CommodityDescription",
        },
        INTO_STORAGE: {
            headerName: "Into Storage",
            field: "IntoStorage",
        },
        BILL_START: {
            headerName: "Bill Start",
            field: "BillStart",
        },
        BILL_END: {
            headerName: "Bill End",
            field: "BillEnd",
        },
        CANCEL_DEBITS: {
            headerName: "Cancelled Debits",
            field: "CancelledDebits",
        },
        EARNED_CREDITS: {
            headerName: "Earned Credits",
            field: "Earned Credits",
        },
        NON_CANCELLED_DEBITS: {
            headerName: "Non-Cancelled Debits",
            field: "NonCancelledDebits",
        },
        CHARGEABLE_DEBITS: {
            headerName: "Chargeable Days/Debits",
            field: "ChargableDebits",
        },
        CONSTR_PLACE: {
            headerName: "Constructive Place",
            field: "ConstructivePlacementDate",
        },
        CONSTR_RELEASE: {
            headerName: "Constructive Release",
            field: "ReleaseFromConstructivePlacementDate",
        },
        ORDER: {
            headerName: "Order",
            field: "OrderedDate",
        },
        PLACEMENT: {
            headerName: "Placement",
            field: "PlacementDate",
        },
        RELEASED: {
            headerName: "Placement Release",
            field: "ReleasedDate",
        },
        CYCLE_TYPE: {
            headerName: "Cycle Type",
            field: "CycleType",
        },
        TOT_DAYS: {
            headerName: "Total Days",
            field: "DemurrageDays",
        },
        FREE_EXCL: {
            headerName: "Free + Excluded",
            field: "CreditDays",
        },
        CHG_DAYS: {
            headerName: "Chargeable Days",
            field: "ChargeDays",
        },
        ACCRUED_CHARGES: {
            headerName: "Accrued Charges",
            field: "ChargeAmount",
        },
    },

    generalPlacementLabels: {
        generalPlacement: "General Placement",
        latestServiceDate: "Latest Service Date",
        reqDate: "Req Date",
        status: "Status",
        requestId: "Request Id",
        serviceDate: "Service Date",
        submitInfo: "Submit Info",
        submittedBy: "Submitted by",
        submittedDate: "Submitted Date",
        equipmentOverview: "Equipment Overview",
        newRequest: "New Request",
        quantity: "Qty",
        loadShortcut: "L",
        emptyShortcut: "E",
        submitRequest: "Submit Request",
        oldestEquipment: "Oldest Equipment",
        newestEquipment: "Newest Equipment",
        largestBlock: "Largest Block",
        easiestAvailable: "Easiest Available",
        selectCriteriaPlacementRequest:
            "Please select criteria for placement request",
        longDesc1:
            "General placement requests for consigned equipment to your facility.",
        longDesc2: "For servicing railroad-supplied equipment,",
        placeAcarOrder: "place a car order.",
        location: "locations",
        equipmentCharacteristics: "equipment characteristics",
        commodityAndCarType: "commodity & car type",
        addtoRequest: "add to request",
        serviceTime: "Service Time",
        maxLength15: "Max length 15 characters",
        specialNotAllowed: "special chars are not allowed",
        maxLength25: "Max length 25 characters",
        servicableDays: "Serviceable days only",
        noRailcarsAdded: "No Cars Added",
        loadLimit: "Load Limit",
        weightOnRail: "Weight on Rail",
        equipmentMark: "Equipment Mark",
        carsForGP: "Cars for General Placement are Requested",
    },

    requestPreference: {
        oldestEquipment: "Oldest Equipment",
        newestEquipment: "Newest Equipment",
        largestBlock: "Largest Block",
        easiestAvailable: "Easiest Available",
    },

    reviewRequestsColumns: {
        QUANTITY: {
            headerName: "Qty",
            field: "quantity",
        },
        LESTATUS: {
            headerName: "L/E",
            field: "leStatus",
        },
        CAR_TYPE: {
            headerName: "Equip Type",
            field: "carType",
        },
        CAR_KIND: {
            headerName: "Equip Kind",
            field: "carKind",
        },
        CAR_MARK: {
            headerName: "Equip Mark",
            field: "carMark",
        },
        TRACK: {
            headerName: "Track",
            field: "trackId",
        },
        POSITION: {
            headerName: "Position",
            field: "trackPosition",
        },
        COMMODITY: {
            headerName: "Commodity",
            field: "commodity",
        },
        STCC: {
            headerName: "STCC",
            field: "stcc",
        },
        RAILWT: {
            headerName: "Rail Wt (lbs)",
            field: "weightOnRail",
        },
        LOADLIMIT: {
            headerName: "Load Limit (lbs)",
            field: "loadLimit",
        },
        PREFERENCE: {
            headerName: "Preference",
            field: "requestPreference",
        },
        COMMENT: {
            headerName: "Comment",
            field: "comment",
        },
    },
    Email: {
        EmailNotifications: "Email Notifications",
        carActions: "car actions",
        carOrders: "car orders",
        generalPlacements: "general placements",
        switchRequests: "Switch Requests",
        modifyEmail: "Modify Email List",
        saveEmails: "Save Emails",
        carOrderTooltip:
            "This will send a notification email to all addresses identified when a car order is requested",
        generalPlacementTooltip:
            "This will send a notification email to all addresses identified when a general placement is requested",
        switchRequestsTooltip:
            "This will send a notification email to addresses identified when a switch request is requested through the switch request menu",
        carActionTooltip:
            "This will send a notification email to all addresses identified for actions preformed in inventory through the action panel",
        emailFormat:
            "*Emails must be in the following format (firstlast@email.com, firstlast@email.com)",
    },
    switchRequestLabels: {
        switchRequestInfo: "SWITCH REQUEST INFO",
        newSwitchRequest: "New Switch Request",
        switchRequestEntry: "Switch Request Entry",
        station: "Station",
        status: "Status",
        individualRequestingService: "Individual Requesting Service",
        requestCreated: "Request Created",
        customer: "Customer",
        shipperId: "Shipper",
        switchRequestPattern: "Switch Request Pattern",
        serviceRequested: "Service Requested",
        time: "Time",
        switchRequests: "Switch Requests",
        switchRequestCreatedSuccessfully: "Request was sent successfully.",
        switchRequestCreateFailed:
            "Request failed please try again or contact your serving railroad.",
        patternUsed: "Pattern used",
        dateRequested: "Date requested",
        dateWanted: "Date wanted",
        switchRequestCreatedelayed:
            "The request is taking longer than expected. We apologize for the inconvenience.",
        cars: "Cars",
    },
    legalDisclaimerFooter: {
        privacyPolicy: "Privacy Policy",
        termsAndConditions: "Terms & Conditions",
        allRightsReserved: "All rights reserved.",
    },
    exceptionValues: {
        badOrder: "Bad order",
        etaDelayed: "Eta delayed",
        outOfRoute: "Out of route",
    },
}
